const initialState = { home_amount: 0, show_fare_amount: 0 };

const ReservationFinancialBalanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case "setreservationFinancialBalance":
      state = action.payload;
      return state;
    default:
      return state;
  }
};

export default ReservationFinancialBalanceReducer;
